import React from "react";
import { useTranslation } from "@hooks/useTranslation";
import PartiesContainer from "../parties";
import Header from "./header";
import AuthorizationDetail from "../parties/authorizationDetail";
import { useDocument } from '@EUForms/hooks/useDocument'
import { CustomLoader } from "@commonComponents/formComponents/loader";
import AddtionalSupplyChainDetail from "../parties/addtionalSupplyChainDetail";
import EconomicOperatorDetail from "../parties/economicOperatorDetail";
import RepeatableContainer from "@containers/repeatableContainer";
import { selectSpecialCountryList } from "@EUForms/selectors";
import { useSelector } from "react-redux";
import { actorActions } from '../../reducer/actorSlice'
import { fieldPatterns } from "../../util/fieldPatterns";
import CCDoc from "./CCDoc";
import { selectHeaderTabDS } from "@EUForms/selectors";

const HeaderContainer=(props)=> {
  const translate=useTranslation()
  const countryList=useSelector(selectSpecialCountryList)
  const transmissionType=useSelector(selectHeaderTabDS)?.transmissionType
  const { addItemParties, updateItemParties, delteItemParties,updatePartiesContactInfo } = actorActions
  const { isLoading, updateContactInfo, ...rest } = useDocument({
    addData: addItemParties,
    updateData: updateItemParties,
    deleteData: delteItemParties,
    updateContact: updatePartiesContactInfo,
    containerKey: 'parties',
  })
  const pattern = React.useMemo(() => fieldPatterns(), [])
  return (
    <div className='headerDetails formContentareaC88'>
      {isLoading && <CustomLoader style={{ position: 'fixed' }} />}
      <Header translate={translate} fieldPattern={pattern} {...props} />
      {transmissionType === 'DOC' && <CCDoc translate={translate} />}
      <PartiesContainer
        countryList={countryList}
        {...rest}
        translate={translate}
        repeatableValidationMethods={props.repeatableValidationMethods}
      />
      <RepeatableContainer
        {...rest}
        tableName='authorizationsList'
        reducerName='actorReducer'
        title='AUTHORIZATION'
        validateError={props.repeatableValidationMethods?.validateError}
        updateErrors={props.repeatableValidationMethods?.updateErrors}
        translate={translate}
        renderForm={(params) => <AuthorizationDetail {...params} />}
      />

      <RepeatableContainer
        {...rest}
        tableName='additionalSupplyChainActorsList'
        reducerName='actorReducer'
        title='ADD_SUPPLY_CHAIN_ACTOR'
        translate={translate}
        validateError={props.repeatableValidationMethods?.validateError}
        updateErrors={props.repeatableValidationMethods?.updateErrors}
        renderForm={(params) => <AddtionalSupplyChainDetail {...params} />}
      />

      <RepeatableContainer
        {...rest}
        tableName='economicOperatorsList'
        reducerName='actorReducer'
        title='ECONOMIC_OPERATOR'
        translate={translate}
        maxRowsAllowed={1}
        renderForm={(params) => (
          <EconomicOperatorDetail
            countryList={countryList}
            updateContactInfo={updateContactInfo}
            {...params}
          />
        )}
      />
      {transmissionType === 'NOT' && (
        <RepeatableContainer
          {...rest}
          tableName='exitCarriersList'
          reducerName='actorReducer'
          title='EXIT_CARRIER'
          translate={translate}
          maxRowsAllowed={1}
          renderForm={(params) => (
            <EconomicOperatorDetail
              countryList={countryList}
              updateContactInfo={updateContactInfo}
              {...params}
            />
          )}
        />
      )}
    </div>
  )
}

export default React.memo(HeaderContainer)
